import { Link } from '@tanstack/react-router';
import { ArrowUpRight } from 'lucide-react';

import { Button } from '@/shared/ui/button';
import { UsageBalance } from '@/shared/usage/usage-balance';

import { summarizePlan } from '../billing-format';

import type { BillingStatus } from '@mio/shared';

/** The learner's current standing plus the way into Stripe's portal. */
export function PlanSummary({
  status,
  onPortal,
  portalBusy,
  showPlansLink = false,
}: {
  status: BillingStatus;
  onPortal: () => void;
  portalBusy: boolean;
  showPlansLink?: boolean;
}) {
  const summary = summarizePlan(status);
  return (
    <div className="space-y-4">
      <div>
        <p className="plan-summary-title">{summary.title}</p>
        {summary.detail ? <p className="plan-summary-detail">{summary.detail}</p> : null}
      </div>
      <UsageBalance usage={status.usage} showPlanLink={showPlansLink} />
      <div className="flex flex-wrap items-center gap-3">
        {status.canManageBilling ? (
          <Button
            type="button"
            variant="secondary"
            onClick={onPortal}
            loading={portalBusy}
            loadingLabel="Opening billing…"
          >
            Manage billing
          </Button>
        ) : null}
        {showPlansLink ? (
          <Link to="/account/plan" className="studio-quiet-link">
            {summary.upgrade ? 'Upgrade' : 'View plans'}{' '}
            <ArrowUpRight className="size-4" aria-hidden="true" />
          </Link>
        ) : null}
      </div>
      {status.canManageBilling ? (
        <p className="text-fg-subtle text-xs leading-5">
          Manage billing opens Stripe, where you can update your card, download invoices and cancel
          a subscription.
        </p>
      ) : null}
    </div>
  );
}
